import { Stores } from '..'

export function useActiveApplication() {
  return Stores.CardApplicationApi.endpoints['GET /card/onboarding/applications'].useQuery(
    {},
    {
      selectFromResult({ data, isLoading, isUninitialized, error }) {
        if (isLoading || isUninitialized) return { status: 'LOADING' as const }
        if (!data && error) return { status: 'ERROR' as const }

        const activeApplication = data?.applications
          .filter((app) => app.platform !== 'HIGHNOTE')
          .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))[0]

        if (!activeApplication) return { activeApplicationStatus: 'NOT_FOUND' as const }

        if (activeApplication.status === 'DOCUMENT_UPLOAD') {
          return {
            activeApplicationId: activeApplication.id,
            activeApplicationStatus: activeApplication.status,
            activeApplicationUploads: activeApplication.uploads,
          }
        }

        return {
          activeApplicationId: activeApplication.id,
          activeApplicationStatus: activeApplication.status,
        }
      },
    },
  )
}
